import rebateMainnet from '@/assets/contract/sonala/idl/mainnet/rebate.json'
import rebate from '@/assets/contract/sonala/idl/rebate.json'
import { Rebate } from '@/assets/contract/sonala/types/rebate'

let rebateAddress = rebate.address
let rebateIDL = rebate as Rebate

enum ENV_MODE {
  PROD = 'production',
  DEV = 'development'
}

if (import.meta.env.VITE_MODE === ENV_MODE.PROD) {
  rebateAddress = rebateMainnet.address
  rebateIDL = rebateMainnet as Rebate
}

const ENV_PARAMS = {
  MODE: import.meta.env.VITE_MODE,
  SITE_DOMAIN: import.meta.env.VITE_SITE_DOMAIN,
  BET_SDK_MODE: import.meta.env.VITE_BET_SDK_MODE,
  QUIKNODE_RPC_URL: import.meta.env.VITE_QUIKNODE_RPC_URL,
  QUIKNODE_RPC_WSS: import.meta.env.VITE_QUIKNODE_RPC_WSS,
  HELIUS_RPC_URL: import.meta.env.VITE_HELIUS_RPC_URL,
  HELIUS_RPC_WSS: import.meta.env.VITE_HELIUS_RPC_WSS,
  TELEGRAM_BOT: import.meta.env.VITE_TELEGRAM_BOT,
  CURVE_RESERVED_TOKENS: import.meta.env.VITE_CURVE_RESERVED_TOKENS,
  AIRDROP_PROGRAM_ID: import.meta.env.VITE_AIRDROP_PROGRAM_ID,
  RAYDIUM_LUNCHPAD_PLATFORM_ID: import.meta.env
    .VITE_RAYDIUM_LUNCHPAD_PLATFOTM_ID,
  PLATFORM_FEE_ADDRESS: import.meta.env.VITE_PLATFORM_FEE_ADDRESS,
  rebateAddress,
  rebateIDL,
  PLATFORM_LOOKUP_TABLE: '6coqBMXQYqjnNfcFyBu9dw54n9qfwZ5oy97oVsrgmacK'
}

export default ENV_PARAMS

export { ENV_MODE, ENV_PARAMS }
